import { useAuth0User } from '@/modules/Context/useAuth0User';
import { Profile } from '@/types/profile';
import { User } from '@/types/user';
import { useEffect, useState } from 'react';

import { getUserProfile } from './useRequest';

export type ClientSideUser = {
  user: User | null;
  userProfile: Profile | null;
};

export const useClientSideUser = (): ClientSideUser => {
  const { user, checkSession, isLoading } = useAuth0User();
  const [userProfile, setUserProfile] = useState<Profile | null>(null);

  useEffect(() => {
    const fetchProfile = async () => {
      await checkSession();
      if (user && !isLoading) {
        const profileResult = await getUserProfile();
        if ('response' in profileResult) {
          setUserProfile(profileResult.response?.data ?? null);
        }
      }
    };
    fetchProfile();
  }, [user?.mr_user_id, isLoading]);

  return { user, userProfile };
};
